import React from 'react';
import { TickerSnapData } from '../../../../types/symbol.types';

interface Props {
  data: TickerSnapData | null;
  market: string;
}

const TickerSnapCard: React.FC<Props> = ({ data, market }) => {
  const formattedVolValue = (((data?.volValue ?? 0) / 1_000_000).toFixed(4)) + 'M';

  const [baseCurrency, quoteCurrency] = market
    ? market.split('-')
    : ['', ''];

  return (
    <>
      {data ? (
        <>
          <div className='flex flex-col'>
            <div className="flex items-center text-[16px] mt-2 font-semibold">
              <img
                src={
                  data.changeRate >= 0
                    ? '/images/icon/up.svg'
                    : '/images/icon/down.svg'
                }
                alt=""
                className="w-4 h-4 mr-1"
              />
              <span
                className={`${data.changeRate >= 0 ? 'text-up' : 'text-down'}`}
              >
                {data.lastTradedPrice.toFixed(2)}
              </span>
            </div>
            <div className={`${data.changeRate >= 0 ? 'text-up' : 'text-down'} text-sm pl-[7px]`}>
              <span title="Change Rate">
                {data.changeRate >= 0 ? '+' : ''}{(data.changeRate * 100).toFixed(2)}%
              </span>
              &nbsp;&nbsp;&nbsp;
              <span title='Change Price'>
                {data.changePrice >= 0 ? '+' : ''}{data.changePrice}
              </span>
            </div>
          </div>
          <div className="flex gap-6 text-sm dark:text-gray-200">
            <div className="flex flex-col">
              <span className="darK:text-gray-500 text-gray-400">24h High</span>
              <span>{data.high.toLocaleString()}</span>
            </div>
            <div className="flex flex-col">
              <span className="darK:text-gray-500 text-gray-400">24h Low</span>
              <span>{data.low.toLocaleString()}</span>
            </div>
            <div className="flex flex-col">
              <span className="darK:text-gray-500 text-gray-400">24h Volume ({baseCurrency})</span>
              <span>{data.vol.toLocaleString()}</span>
            </div>
            <div className="flex flex-col">
              <span className="darK:text-gray-500 text-gray-400">24h Volume ({quoteCurrency})</span>
              <span>{formattedVolValue}</span>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='flex flex-col gap-1'>
            <div className="flex items-center text-[16px] mt-2 font-semibold gap-2">
              <div className="h-[20px] w-[120px] animate-pulse bg-gray-600 rounded"></div>
            </div>
            <div className="text-sm  flex gap-2">
              <div className="h-[12px] w-[50px] animate-pulse bg-gray-600 rounded"></div>
              <div className="h-[12px] w-[65px] animate-pulse bg-gray-600 rounded"></div>
            </div>
          </div>
          <div className="flex gap-6 text-sm text-gray-200 mt-2">
            <div className="flex flex-col gap-2">
              <div className="h-[14px] w-[70px] animate-pulse bg-gray-600 rounded"></div>
              <div className="h-[16px] w-[70px] animate-pulse bg-gray-600 rounded"></div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="h-[14px] w-[70px] animate-pulse bg-gray-600 rounded"></div>
              <div className="h-[16px] w-[70px] animate-pulse bg-gray-600 rounded"></div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="h-[16px] w-[100px] animate-pulse bg-gray-600 rounded"></div>
              <div className="h-[16px] w-[100px] animate-pulse bg-gray-600 rounded"></div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="h-[16px] w-[100px] animate-pulse bg-gray-600 rounded"></div>
              <div className="h-[16px] w-[100px] animate-pulse bg-gray-600 rounded"></div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TickerSnapCard;
